import styled from "styled-components";
import screenSizes from "../../../utils/screenSizes";

export const FooterContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px 100px;

  padding: 90px 80px;

  >div {
    
    gap: 55px;
    
    &:first-child {
      color: var(--color-white);
      font-size: 26px;
      font-weight: 200;

      img {
        text-align: left;
        margin-bottom: 75px;
      }

      p {
        max-width: 475px;
      }
    }
  }

  @media (max-width: 1600px) {
    grid-template-columns: repeat(2, 1fr);

    margin: 25px 0 50px;
  }

  @media (max-width: 1020px) {
    grid-template-columns: repeat(1, 1fr);

    margin: 25px 0 50px;
    padding: 0;
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 0 20px;
    
    >div:first-child {
      text-align: center;
      
      >img {
        height: 30px;
        margin-bottom: 20px;
      }
      
      p {
        font-size: 20px;
        font-weight: 300;
        text-align: center;
      }
    }
    
    >div:nth-last-child(-n + 3) {
      margin-top: 50px;
      
      >div {
        margin-bottom: 25px;
      }
      
      ul {
        flex-direction: row;
        flex-wrap: wrap;
        
        li {
          flex: 1 1 45%;
        }
      }
    }

    >div:nth-child(4) {
      > div {
        gap: 5px;

        img {
          height: 28px;
        }
      }

      ul {
        flex-direction: column;
        align-items: center;

        li a {
          font-size: 20px;
          font-weight: 400;
        }
      }
    }
  }
`

export const Label = styled.div `
  color: var(--color-white);
  font-size: 36px;
  font-weight: 500;
  
  margin-bottom: 50px;
`

export const FooterMenuContainer = styled.div `
  justify-content: flex-start;
  align-items: flex-start;
  
  ul {
    display: flex;
    flex-direction: column;
    gap: 20px;
    
    list-style: none;
    padding: 0;
    
    li {
      
      a {
        color: var(--color-white);

        font-size: 30px;
        font-weight: 300;
      }
    }
  }
`
